import React, { useState } from "react";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

export default function SidekickAccordion({
  index,
  openIndex,
  setOpenIndex,
  title = "",
  content = "",
}) {

  const isOpen = openIndex === index;

  return (
    <div>
      <Accordion
        expanded={isOpen}
        onChange={() => setOpenIndex(isOpen ? null : index)}
        sx={{ boxShadow: "none" }}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls={`panel-${index}-content`}
          id={`panel-${index}-header`}
        >
          <span className="text-[#737373] text-[13px] md:text-[15px] font-playfair font-medium">
            {title}
          </span>
        </AccordionSummary>
        <AccordionDetails className="-mt-4">
          <hr class="h-[0.5px] bg-[#737373] border-none opacity-50" />
          <span className="text-[#737373] text-xs md:text-[14px] font-inter">
            {content}
          </span>
        </AccordionDetails>
      </Accordion>
    </div>
  );
}
